// @flow

type Work = () => void;

// `requestIdleCallback` with a cheap polyfill
const runWhenIdle =
  global.requestIdleCallback || ((work: Work) => setTimeout(work, 1));

export default runWhenIdle;
